import PostalCodeQueryWidget from '@components/components/PhotovoltaicsCalculator/PostalCodeQueryWidget/PostalCodeQueryWidget';
import React from 'react';

const CmsPostalCodeQueryWidget = ({ availableSite, unavailableSite }) => (
  <PostalCodeQueryWidget
    availableSite={availableSite}
    unavailableSite={unavailableSite}
  />
);

export default CmsPostalCodeQueryWidget;
